module.exports = __webpack_public_path__ + "static/media/jeux-divertissements.9e51dd5d.webp";